<template>
  <div class="container"
       style="display: flex">
    <div style="width: 10%">
      <!-- 左侧树形分类 -->
      <tree></tree>
    </div>
    <div style="width: 90%">
      <!-- 搜索栏部分 -->
      <Search @getHeight="getHeight"
              @add="add()"
              @saveSet="saveSet"
              ref="Search"
              :tableData="tableData"
              :delPara="delPara"
              :isquery="true"
              :isSort="true"
              :functionBtn="true"
              :isAdd="true"
              :tableConfig="tableConfig"
              :tableName="tableName"
              :sortPara="sortPara"
              searchName="getUserBonusByBrokerDetailPage">
        <!-- 普通查询部分开始 -->
        <template v-slot:left>
          <el-col class="first"
                  :lg="24"
                  :md="24"
                  :sm="24"
                  :xs="24">
            <el-form-item label="关键字"
                          prop="keyWord">
              <el-input @keyup.enter.native="handleSearch"
                        v-model="searchForm.keyWord"
                        clearable
                        placeholder="请输入关键字查询"></el-input>
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:center>
          <el-button size="small "
                     type="success"
                     plain
                     @click="batchconFirmation"
                     icon="el-icon-edit-outline"
                     v-if="verifyPermission('Update')">批量确认金额</el-button>
          <el-button size="small "
                     type="success"
                     plain
                     @click="openCommission()"
                     icon="el-icon-upload"
                     v-if="verifyPermission('Add')">导入佣金表</el-button>

          <el-button style="float: right"
                     size="small "
                     type="success"
                     plain
                     @click="downloadDoc"
                     icon="el-icon-download">下载佣金模板</el-button>
        </template>
        <!-- 普通查询部分结束 -->

        <!-- 高级查询部分开始 -->
        <template v-slot:advancedQuery>
          <el-col :lg="4"
                  :md="6"
                  :sm="12"
                  :xs="24">
            <el-form-item label="选择年月"
                          prop="isCooperation">
              <el-date-picker v-model="searchForm.yearMonth"
                              type="month"
                              placeholder="选择年月"
                              value-format="yyyy-MM">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </template>
        <!-- 高级查询部分结束 -->
      </Search>
      <!-- 查询栏结束 -->

      <!-- 表格栏开始 -->
      <MyTable @selectionChange="handleSelectionChange"
               @sortChange="sortChange"
               @inputChange="inputChange"
               @selectChange="selectChange"
               :tableData="tableData"
               :tableConfig="tableConfig"
               tableType="selection"
               :height="tableHeight"
               :width="'width: calc(100% )'"
               :indexFlag="true"
               :showSummary="true"
               :totalRule="totalRule">
        <!-- 插槽部分开始 -->
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:cname="slotData">
          {{ slotData.scope.row.cname }}
        </template>

        <template v-slot:sort="slotData">
          <el-input-number size="small"
                           v-model="slotData.scope.row.sort"
                           controls-position="right"
                           :precision="0"
                           @change="slotData.scope.row.add = '1'"></el-input-number>
        </template>

        <template v-slot:operation="slotData">
          <el-button @click="openCommission(slotData.scope.row)"
                     type="primary"
                     plain
                     size="small"
                     v-if="verifyPermission('Update')">弹窗</el-button>
          <el-button @click="drawerTable(slotData.scope.row)"
                     type="primary"
                     plain
                     size="small"
                     v-if="verifyPermission('Update')">抽屉表格</el-button>
          <el-button @click="edit(slotData.scope.row)"
                     plain
                     type="primary"
                     size="small"
                     icon="el-icon-edit"
                     v-if="verifyPermission('Update')">抽屉表单</el-button>
          <el-button @click="onlyDel(slotData.scope.row.id)"
                     type="danger"
                     plain
                     size="small"
                     icon="el-icon-delete"
                     v-if="verifyPermission('Delete')">删除</el-button>
          <el-button @click="updateAmount(slotData.scope.row)"
                     v-if="verifyPermission('Update')"
                     type="primary"
                     plain
                     size="small"
                     icon="el-icon-collection">保存</el-button>
          <el-dropdown style="margin-left: 10px"
                       trigger="click"
                       @command="handleCommand">
            <el-button type="primary"
                       plain
                       size="small">更多 <i class="el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-picture-outline"
                                :command="{ command: 'image', row: slotData.scope.row }"
                                v-if="verifyPermission('Add')">更多一</el-dropdown-item>
              <el-dropdown-item icon="el-icon-view"
                                :command="{ command: 'check', row: slotData.scope.row }"
                                v-if="verifyPermission('Add')">更多二</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <!-- 插槽部分结束 -->
      </MyTable>
      <!-- 表格栏结束 -->

      <!-- 分页 -->
      <Pagination class="PagPosition"
                  :total="total"
                  @getNewData="getUserBonusByBrokerDetailPage"
                  ref="pagination" />

      <el-dialog title="导入佣金表"
                 :visible.sync="dialogVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="450px"
                 class="colleague-dialog"
                 @close="resetForm">
        <el-form ref="form"
                 :model="form"
                 :inline="true"
                 :rules="rules">
          <el-form-item label="选择时间"
                        prop="time">
            <el-date-picker v-model="form.time"
                            type="month"
                            placeholder="选择年月"
                            value-format="yyyy-MM">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="单位名称"
                        prop="companyid">
            <el-select v-model="form.companyid"
                       placeholder="请选择单位名称"
                       ref="companyName"
                       class="company"
                       filterable>
              <el-option v-for="item in companyList"
                         :key="item.Id"
                         :label="item.customerName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-col :span="24">
            <el-form-item label="上传Excel文件"
                          prop="excel">
              <input type="file"
                     ref="fileadd"
                     @change="getfile" /></el-form-item>
          </el-col>
          <el-form-item label="状态"
                        prop="isStop">
            <el-radio-group v-model="form.isStop">
              <el-radio :label="false">启用</el-radio>
              <el-radio :label="true">停用</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="是否管理员">
          <el-switch v-model="form.isManage"></el-switch>
        </el-form-item> -->
        </el-form>
        <span slot="footer">
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="addExcel('form')">确 定</el-button>
        </span>
      </el-dialog>

      <addAndEdit :drawerShow="addDrawerShow"
                  :title="drawerTitle"
                  :operation="operation"
                  :Info="Info"
                  @colseDrawer="addDrawerShow = false"
                  @refreshData="
          () => {
            getCustomerList();
          }
        " />
      <drawerTable :visible.sync="sourceBonusVisible"
                   :row="sourceBonusRow" />
    </div>
  </div>
</template>


<script>
import addAndEdit from "./addAndEdit";
import { verifyPermissionMinix } from "@/utils/mixin";
import Search from "@/components/Search";
import MyTable from "@/components/Table";
import tree from "@/components/Tree";
import drawerTable from "./drawerTable";
export default {
  components: {
    Search,
    MyTable,
    addAndEdit,
    drawerTable,
    tree,
  },
  mixins: [verifyPermissionMinix],
  data () {
    let valiIcon = (rule, value, callback) => {
      if (this.currentfile == "") {
        callback(new Error("请上传excel文件"));
      } else {
        callback();
      }
    };
    return {
      sortPara: {
        data: "",
        controller: "manage",
        action: "BannerUpdateSort",
        callback: "BannerUpdateSort",
      },
      delPara: {
        data: "",
        controller: "user",
        action: "BatchDeleteBrokerDetail",
        callback: "getUserBonusByBrokerDetailPage",
      },

      sortType: "1",
      tableName: "demoDableConfig",
      tableConfig: [
        {
          field: "atYear",
          label: "双击输入框",
          width: "120",
          sortable: true,
          style: 1,
          flag: true,
        },
        {
          field: "atMonth",
          label: "双击下拉",
          width: "120",
          align: "center",
          sortable: true,
          style: 2,
          flag: true,
          list: [
            { text: "选项一", value: true },
            { text: "选项二", value: false },
          ],
        },
        {
          field: "cname",
          label: "双击日期选择",
          align: "center",
          slotName: "cname",
          style: 3,
          flag: true,
        },
        {
          field: "sort",
          label: "排序",
          align: "center",
          width: "170",
          slotName: "sort",
          flag: true,
        },
        {
          label: "直接上级",
          align: "center",
          flag: true,
          children: [
            {
              field: "directName",
              label: "经纪人",
              align: "center",
              width: "100",
              flag: true,
            },

            {
              field: "directBonusMoney",
              label: "奖金金额",
              align: "center",
              flag: true,
            },
          ],
        },
        {
          label: "操作",
          slotName: "operation",
          width: 550,
          align: "center",
          flag: true,
        },
      ],
      totalRule: [],
      Info: "",
      sourceBonusRow: "",
      lstSelectedData: [],
      tableHeight: "",
      searchList: [],
      testDialogVisible: false,
      companyList: [],
      submitLoading: false,
      dialogVisible: false,
      loading: false,
      sourceBonusVisible: false,
      currentPage: 1,
      tableData: [
        {
          atYear: "双击输入框",
          atMonth: "选项一",
          cname: "2022-03-01",
          directName: "林",
          sort: 1,
          directBonusMoney: 10,
        },
        {
          atYear: "双击输入",
          atMonth: "选项一",
          cname: "2022-03-02",
          sort: 2,
          directBonusMoney: 20,
        },
        { atYear: "双击输入框", atMonth: "选项一", cname: "2022-03-03" },
        { atYear: "双击输入", atMonth: "选项一", cname: "2022-03-04" },
      ],
      searchForm: {
        checked: [],
      },
      form: {},
      rules: {
        excel: [{ required: true, validator: valiIcon }],
        time: [{ required: true, message: "请选择时间", trigger: "blur" }],
        companyid: [
          {
            required: true,
            message: "请选择单位",
            trigger: ["blur", "change"],
          },
        ],
      },
      roleList: [],
      total: 0,
      isEdit: false,
      industryData: [],
      customerIds: [],
      currentfile: "",
      drawerTitle: "",
      operation: "",
      addDrawerShow: false,
    };
  },
  mounted () {
    this.getCompanyList();
    // 初始化获取数据
    this.getUserBonusByBrokerDetailPage();
    this.totalRule[7] = { nums: true, total: true, totalNum: 123456 };
    //初始化设置列的隐藏和排序方法
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
  },
  computed: {},

  methods: {
    //获取列的隐藏数据
    saveSet (checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    // filed:改变的字段名,row:整行的数据,value:选择的值
    //表格输入框
    inputChange (value, field, row) { },
    //表格下拉选择
    selectChange (value, field, row) { },
    //表格选择日期
    selectDate (value, field, row) { },
    //弹窗
    openDialog () {
      this.dialogVisible = true;
    },

    //弹窗表格
    drawerTable (row) {
      this.sourceBonusVisible = true;
    },
    //弹窗表单
    add (event) {
      //新建还是修改的标识
      this.operation = "add";
      //展开面板
      this.addDrawerShow = true;
      //设置标题
      this.drawerTitle = "新增面板";
    },
    edit (event) {
      //新建还是修改的标识
      this.operation = "edit";
      //展开面板
      this.addDrawerShow = true;
      //设置标题
      this.drawerTitle = "修改面板";
    },

    //表格排序
    sortChange (column) {
      if (this.sortType == "custom") {
        this.tableData = [
          { atYear: "双击输入框", atMonth: "选项一", cname: "2022-03-01" },
          { atYear: "双击输入", atMonth: "选项一", cname: "2022-03-04" },
          { atYear: "双击输入框", atMonth: "选项一", cname: "2022-03-03" },
          { atYear: "双击输入", atMonth: "选项一", cname: "2022-03-02" },
        ];
      }
    },
    //批量选择
    handleSelectionChange (selection) {
      this.delPara.data = selection.map((v) => {
        return v.id;
      });
    },
    onlyDel (id) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.$api.manage.MessageDelete(id).then((res) => {
          // 
          //   if (res.error === false) {
          //     this.getNoticeList();
          //     this.$message.success("删除成功");
          //   }
          // });
        })
        .catch(() => { });
    },
    //计算表格高度
    getHeight (height) {
      this.tableHeight = height;
    },
    //下载文件
    downloadDoc () {
      // 创建一个<a></a>标签
      const a = document.createElement("a");
      a.href = "../excel/salaryTemplate.xlsx";
      a.download = "salaryTemplate.xlsx";

      // 障眼法藏起来a标签
      a.style.display = "none";
      // 将a标签追加到文档对象中
      document.body.appendChild(a);
      // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
      a.click();
      // 一次性的,用完就删除a标签
      a.remove();
    },
    // 新增
    addPeople () {
      this.submitLoading = true;
      let name = "";
      if (this.form.companyid) {
        this.companyList.forEach((item) => {
          if (item.id == this.form.companyid) {
            name = item.customerName;
          }
        });
      }
      let sendData = {
        factoryId: this.form.companyid,
        factoryName: name,
        staffName: this.form.staffName,
        identityCard: this.form.identityCard,
        workDate: Number(this.form.workDate),
        atYear: Number(this.form.yearMonth.split("-")[0]),
        atMonth: Number(this.form.yearMonth.split("-")[1]),
      };
      this.$api.user.UserBonusByBrokerDetailAdd(sendData).then((res) => {

        if (res.error === false) {
          this.$message.success("新增成功");
          this.testDialogVisible = false;
          this.submitLoading = false;
          this.getUserBonusByBrokerDetailPage();
          this.resetForm();
        }
      });
    },
    // 文件上传
    getfile (e) {
      this.currentfile = this.$refs.fileadd.files[0];
      console.log(this.currentfile);
    },

    // 批量确认
    batchconFirmation () {
      if (this.customerIds.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      this.$confirm("批量确认金额吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      }).then(() => {
        let sendData = this.customerIds;
        this.$api.user.BatchNotarizeBrokerDetail(sendData).then((res) => {
          if (res.error === false) {
            this.$message.success("确认成功");
            this.getUserBonusByBrokerDetailPage();
          }
        });
      });
    },

    // 更多
    handleCommand (command) {
      console.log(command.row);
      switch (command.command) {
        case "image":
          // this.imageManage(command.row);
          break;
        case "check":
          // this.addOnSite(command.row);
          break;
      }
    },
    // 更新金额
    updateAmount (row) {
      let sendData = {
        id: row.id,
        workDate: row.workDate,
        directBonusMoney: row.directBonusMoney ? row.directBonusMoney : 0,
        directSubsidy: row.directSubsidy ? row.directSubsidy : 0,
        directTotalMoney:
          Number(row.directBonusMoney) + Number(row.directSubsidy),
        inDirectBonusMoney: row.inDirectBonusMoney ? row.inDirectBonusMoney : 0,
        inDirectSubsidy: row.inDirectSubsidy ? row.inDirectSubsidy : 0,
        inDirectTotalMoney:
          Number(row.inDirectBonusMoney) + Number(row.inDirectSubsidy),
      };
      this.$api.user.UserBonusByBrokerDetailEdit(sendData).then((res) => {
        if (res.error === false) {
          this.$message.success("保存成功");
          this.getUserBonusByBrokerDetailPage();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取公司列表
    getCompanyList () {
      this.$api.customer.getAllCustomerList().then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
        }
      });
    },

    // 获取分页数据
    getUserBonusByBrokerDetailPage () {
      this.loading = true;
      let year = "";
      let month = "";
      if (this.searchForm.yearMonth) {
        year = this.searchForm.yearMonth.split("-")[0];
        month = this.searchForm.yearMonth.split("-")[1];
      }
      let Data = "";
      let sendData = {};
      sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
      };
      // console.log(this.searchForm);
      Data = {
        month: month,
        keyWord: this.searchForm.keyWord,
        year: year,
      };
      // console.log(sendData);
      for (let i in Data) {
        if (Data[i] != undefined) {
          sendData[i] = Data[i];
        }
      }
      this.$api.user.UserBonusByBrokerDetailPage(sendData).then((res) => {
        if (res.error === false) {
          this.loading = false;
          this.tableData = res.data.data;
          this.sortPara.data = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    //重置表单
    resetForm () {
      this.form = {};
      this.$refs.fileadd.value = "";
      this.$refs.form.clearValidate();
    },
    //上传excel文件
    addExcel (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        var formData = new FormData();

        formData.append("factoryId", this.$refs["companyName"].selected.value);
        formData.append(
          "factoryName",
          this.$refs["companyName"].selected.label
        );
        formData.append("atYear", this.form.time.split("-")[0]);
        formData.append("atMonth", this.form.time.split("-")[1]);
        formData.append("file", this.currentfile);
        console.log(formData);
        this.$api.user.ImportWaitCalculateData(formData).then((res) => {

          if (res.code === 0) {
            this.$message.success("上传成功");
            this.getUserBonusByBrokerDetailPage();
          } else {
            this.$message.error(res.msg);
          }
          this.submitLoading = false;
          this.dialogVisible = false;
          this.$refs[formName].resetFields();
        });
      });
    },
    //打开弹窗
    openCommission (row) {
      this.dialogVisible = true;
      this.currentRow = row;
    },
    //获取用户列表
    getUserList () {
      this.loading = true;
      const sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        name: this.searchForm.name,
        deptId: this.searchForm.department,
        roleId: this.searchForm.auth,
        isManage: "",
      };
      this.$api.user.getUserList(sendData).then((res) => {
        this.loading = false;
        if (res.code === 0) {
          this.tableData = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    //获取角色列表
    getRoleList () {
      this.$api.role.getRoles().then((res) => {
        if (res.code === 0) {
          this.roleList = res.data;
        }
      });
    },
    //查询
    // handleSearch() {
    //   this.$refs.pagination.currentPage = 1;
    //   this.$refs.pagination.pageSize = 20;
    //   this.getUserBonusByBrokerDetailPage();
    // },
  },
  computed: {},
  watch: {
    // customerIds: {
    //   handler() {
    //     this.delPara = {
    //       data: this.customerIds,
    //       controller: "user",
    //       action: "BatchDeleteBrokerDetail",
    //       callback: "getUserBonusByBrokerDetailPage",
    //     };
    //   },
    // },
  },
};
</script>

<style lang="less">
.colleague-dialog {
  .el-input__inner {
    width: 200px !important;
  }
}
</style>
